export default "__VITE_ASSET__d20cb53d__"